function updateBlogFilterResults(event) {
	if (dragging) return;

	var target = event.target.closest("#blog-filter-sort select");
	if (target) {
		var filterForm = document.getElementById("blog-filter-sort");

		var fields = filterForm.querySelectorAll("select");
		for (var i = 0; i < fields.length; i++) {
			var field = fields[i],
				fieldLabel = fields[i].closest("label");

			if (fieldLabel !== null & window.getComputedStyle(fieldLabel).display == 'none') {
				field.disabled = true;
			}
		}

		filterForm.submit();
	}
}

document.addEventListener("change", updateBlogFilterResults);